import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { EMPTY, pipe, switchMap } from 'rxjs';
import { ManagementService } from '@thiememeulenhoff/ng-api-gateway';
import { ManagementReader } from '@thiememeulenhoff/types';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type ManagementReadersState = {
  readers: Array<ManagementReader>;
};

const initialState: ManagementReadersState = {
  readers: [],
};

export const ManagementReadersStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(),
  withMethods((store, managementService = inject(ManagementService)) => {
    const fetchManagementReaders = rxMethod<void>(
      pipe(
        switchMap(() => {
          if (store.readers().length > 0) {
            patchState(store, { requestStatus: 'success' });
            return EMPTY;
          }

          patchState(store, { requestStatus: 'loading' });

          return managementService.fetchReaders().pipe(
            tapResponse({
              next: (readers) =>
                patchState(store, { readers, requestStatus: 'success' }),
              error: (error: unknown) =>
                patchState(store, {
                  requestStatus: toRequestError(
                    error,
                    'Could not load readers.',
                  ),
                }),
            }),
          );
        }),
      ),
    );

    return {
      fetchManagementReaders,
    };
  }),
);
